import React, { useMemo, useState } from "react";
import "./big-event.css";

export default function EventReports() {
  const events = useMemo(
    () => [
      { id: "bb-slc-2025", name: "Breaking Barriers — Salt Lake City" },
      { id: "naol-aug", name: "New Art of Living — August Tour" },
    ],
    []
  );
  const [eventId, setEventId] = useState(events[0].id);
  const [activeReport, setActiveReport] = useState(null);

  // Mock dashboard metrics — replace with live aggregates later
  const dash = {
    ticketsSold: 3821,
    checkedIn: 1234,
    scanRate: "32.3%",
    revenue: "$476,300",
  };

  const defaultReports = [
    "Sales by Package",
    "Check-ins by Hour",
    "No-Show List",
    "Top Recruiters at Event",
    "Merch Preorders",
  ];

  const handleReportClick = (reportName) => {
    setActiveReport(reportName);
    // TODO: Load actual report data from Firebase/Firestore
    console.log(`Loading report: ${reportName} for event: ${eventId}`);
  };

  const handleExport = () => {
    // TODO: Implement CSV/PDF export
    alert(`Exporting report data for event: ${eventId}\n\nThis will generate a downloadable file with all metrics.`);
  };

  const handleCustomReport = () => {
    // TODO: Open custom report builder modal
    alert(`Custom Report Builder\n\nConfigure:\n- Time range\n- Metrics\n- Filters\n- Export format`);
  };

  return (
    <div className="be-wrap">
      <div className="be-header">
        <div>
          <h2 className="be-title">Reports</h2>
          <p className="be-subtitle">
            Live dashboard for each active event + quick access to default and
            custom reports.
          </p>
        </div>
        <div className="be-header-right">
          <select
            className="input input-compact"
            value={eventId}
            onChange={(e) => setEventId(e.target.value)}
          >
            {events.map((e) => (
              <option key={e.id} value={e.id}>
                {e.name}
              </option>
            ))}
          </select>
          <button className="btn subtle" onClick={handleExport}>Export</button>
        </div>
      </div>

      {/* Mini dashboard */}
      <div className="be-mini-dash">
        <div className="kpi-card mini">
          <div className="kpi-label">Tickets Sold</div>
          <div className="kpi-value">{dash.ticketsSold.toLocaleString()}</div>
          <div className="kpi-muted">All packages</div>
        </div>
        <div className="kpi-card mini">
          <div className="kpi-label">Checked-in</div>
          <div className="kpi-value">{dash.checkedIn.toLocaleString()}</div>
          <div className="kpi-muted">Live scans</div>
        </div>
        <div className="kpi-card mini">
          <div className="kpi-label">Scan Rate</div>
          <div className="kpi-value">{dash.scanRate}</div>
          <div className="kpi-muted">Checked-in / Tickets</div>
        </div>
        <div className="kpi-card mini">
          <div className="kpi-label">Revenue</div>
          <div className="kpi-value">{dash.revenue}</div>
          <div className="kpi-muted">Gross (est.)</div>
        </div>
      </div>

      {/* Quick default reports */}
      <div className="be-card" style={{ padding: 14 }}>
        <div className="be-row between">
          <div className="action-row">
            {defaultReports.map((r) => (
              <button 
                key={r} 
                className={`chip ${activeReport === r ? 'chip-active' : ''}`}
                onClick={() => handleReportClick(r)}
              >
                {r}
              </button>
            ))}
          </div>
          <button className="gold-button" onClick={handleCustomReport}>Custom Report</button>
        </div>
      </div>

      {/* Sample table area */}
      <div className="be-card">
        <div className="be-table-wrap">
          <table className="be-table compact">
            <thead>
              <tr>
                <th>Metric</th>
                <th>Today</th>
                <th>Yesterday</th>
                <th>7-day</th>
                <th>All-time</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Tickets sold</td>
                <td>42</td>
                <td>38</td>
                <td>261</td>
                <td>3,821</td>
              </tr>
              <tr>
                <td>Check-ins</td>
                <td>315</td>
                <td>288</td>
                <td>1,478</td>
                <td>1,234</td>
              </tr>
              <tr>
                <td>Refunds</td>
                <td>2</td>
                <td>1</td>
                <td>6</td>
                <td>37</td>
              </tr>
              <tr>
                <td>Merch preorders</td>
                <td>19</td>
                <td>15</td>
                <td>88</td>
                <td>341</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="edit-placeholder muted small">
          Tip: click a chip above to run a default report, or “Custom Report” to
          choose filters (event, time range, packages, seats, scanners, etc.).
        </div>
      </div>
    </div>
  );
}
